<template>
    <section id="hero">
        <v-row no-gutters>
            <v-img
                :height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
                max-height="500"
                :src="require('../assets/traverse-board.jpg')"
                gradient="to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)"
            >
                <!--<v-row align="end" class="fill-height">
                    <v-col>
                        <div class="big-text pb-3 font-weight-black mx-3">
                            <span class="px-1" style="white-space: nowrap; display: inline-block;">CHINESE CHECKERS</span>
                            <span class="px-1" style="white-space: nowrap; display: inline-block;">GONE WILD</span>
                        </div>
                    </v-col>
		</v-row>-->
            </v-img>
        </v-row>
    </section>
</template>

<script>
    export default {
        name: 'Hero',
        data () {
            return {

            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }
    .big-text {
        font-family: Roboto;
        font-size: 36px;
        color: #fff;
        line-height: 1.1;
        text-shadow: 2px 2px #222;
    }
    @media screen and (max-width: 400px) {
        .big-text {
            font-size: 30px;
        }
    }
</style>
